import { lazy } from 'react';

const AsyncLanding = lazy(() => import('../containers/shared/landing'));

// exports
const AsyncMetabaseDataExport = lazy(() => import('../containers/shared/export'));
const AsyncMetabaseDataExportQuestion = lazy(() => import('../containers/shared/export/Question'));
const AsyncExport = lazy(() => import('../containers/shared/export/AttributeExportDashboard'));
const AsyncProgrammeStats = lazy(() => import('../containers/shared/export/ProgrammeStatsDashboard'));

// reports
const AsyncReports = lazy(() => import('../containers/shared/reports'));
const AsyncReportDetails = lazy(() => import('../containers/shared/reports/Details'));

// manage institutions
const AsyncInstitutions = lazy(() => import('../containers/institution/institutions'));
const AsyncArchivedInstitutions = lazy(() => import('../containers/institution/institutions/AllArchivedInstitutions'));
const AsyncInstitutionDetails = lazy(() => import('../containers/institution/institutions/InstitutionDetails'));
const AsyncECDServiceDetails = lazy(() => import('../containers/institution/institutions/ECDService/Details'));
const AsyncECDServiceContacts = lazy(() => import('../containers/institution/institutions/ECDService/Contacts'));
const AsyncECDServiceRegistrationManagement = lazy(() =>
  import('../containers/institution/institutions/ECDService/Registration')
);
const AsyncECDRegistrations = lazy(() => import('../containers/institution/institutions/AllEcds'));
const AsyncECDApplication = lazy(() => import('../containers/institution/institutions/ecdRegistration/application'));
const AsyncECDFramework = lazy(() => import('../containers/institution/institutions/ecdRegistration/framework'));
const AsyncECDApproval = lazy(() => import('../containers/institution/institutions/ecdRegistration/approval'));
const AsyncECDAssessment = lazy(() => import('../containers/institution/institutions/ecdRegistration/assessment'));
const AsyncECDComplete = lazy(() => import('../containers/institution/institutions/ecdRegistration/complete'));

const AsyncInstitutionTemplates = lazy(() => import('../containers/institution/templates/AllInstitutionTemplates'));
const AsyncInstitutionTemplateDetails = lazy(() => import('../containers/institution/templates/template'));

const AsyncTeamMembers = lazy(() => import('../containers/institution/teamMembers'));
const AsyncTeamMembersCreate = lazy(() => import('../containers/institution/teamMembers/forms/CreateForm'));

const AsyncProfile = lazy(() => import('../containers/shared/profile'));
const AsyncInsights = lazy(() => import('../containers/shared/insights/AllInsights'));
const AsyncInsightsEmbedFrame = lazy(() => import('../containers/shared/insights/InsightsEmbedReport'));
const AsyncInsightsDetails = lazy(() => import('../containers/institution/Insights/forms/Details'));

const AsyncDashboards = lazy(() => import('../containers/shared/dashboard'));
const AsyncReportingRequirements = lazy(() => import('../containers/shared/reportingRequirements'));
const AsyncReportingRequirementDetail = lazy(() =>
  import('../containers/shared/reportingRequirements/RequirementDetail')
);
const AsyncDashboardsDashboard = lazy(() => import('../containers/shared/dashboard/Dashboard'));
const AsyncDashboardsUsers = lazy(() => import('../containers/shared/dashboard/DashboardUsers'));
const AsyncInsightUsers = lazy(() => import('../containers/shared/insights/InsightUsers'));
const AsyncManageInsights = lazy(() => import('../containers/institution/Insights'));
const AsyncDashboardsMetabase = lazy(() => import('../containers/shared/dashboard/Metabase'));
const AsyncNewDashboardLayout = lazy(() => import('../containers/shared/dashboard/newDashboardLayout'));

const AsyncNotifications = lazy(() => import('../containers/shared/notifications'));

// people
const AsyncPeople = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleProfileDetails = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));
const AsyncAddPeopleTable = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));
const AsyncPeopleCohorts = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleCohortDetails = lazy(() => import('../containers/shared/peopleProfiles/CohortDetails'));

// admin
const AsyncAdminPage = lazy(() => import('../containers/shared/admin'));
const AsyncAdminWorkspaceCreate = lazy(() => import('../containers/institution/admin/workspace/CreateForm'));
const AsyncAdminWorkspaceOverview = lazy(() => import('../containers/shared/admin/overview'));
const AsyncAdminWorkspaceDatasetCreate = lazy(() => import('../containers/shared/admin/datasets/Dataset'));
const AsyncAdminWorkspaceFormCreate = lazy(() => import('../containers/shared/admin/forms/CreateForm'));
const AsyncAdminModules = lazy(() => import('../containers/shared/admin/modules'));
const AsyncAdminAuditTrail = lazy(() => import('../containers/shared/admin/auditTrail'));
const AsyncAdminOrganisations = lazy(() => import('../containers/shared/admin/organisations'));
const AsyncAdminOrganisationsUsers = lazy(() => import('../containers/shared/admin/organisations/users'));
const AllWorkspaces = lazy(() => import('../containers/institution/admin/workspace'));

// programme / portfolio / interventions
const AsyncProgramme = lazy(() => import('../containers/shared/programmes'));
const AsyncProgrammeOverview = lazy(() => import('../containers/shared/programmes/overview'));
const AsyncProgrammeIndicators = lazy(() => import('../containers/shared/programmes/indicators'));
const AsyncProgrammeMonitoring = lazy(() => import('../containers/shared/programmes/monitoring'));
const AsyncProgrammeComplete = lazy(() => import('../containers/shared/programmes/summary'));
const AsyncProgrammeSites = lazy(() => import('../containers/shared/programmes/sites'));
const AsyncProgrammeHierarchies = lazy(() => import('../containers/shared/programmes/sites/hierarchies'));
const AsyncProgrammeHierarchy = lazy(() => import('../containers/shared/programmes/sites/hierarchies/hierarchy'));
const AsyncProgrammeServices = lazy(() => import('../containers/shared/programmes/sites/services'));
const AsyncProgrammeService = lazy(() => import('../containers/shared/programmes/sites/services/service'));
const AsyncProgrammeReporters = lazy(() => import('../containers/shared/programmes/reporters'));
const AsyncProgrammeReporterAssignees = lazy(() => import('../containers/shared/programmes/reporters/assignees'));
const AsyncInterventionOverview = lazy(() => import('../containers/shared/interventions/overview'));
const AsyncInterventionIndicators = lazy(() => import('../containers/shared/interventions/indicators'));
const AsyncInterventionInputs = lazy(() => import('../containers/shared/interventions/inputs'));
const AsyncInterventionActivities = lazy(() => import('../containers/shared/interventions/activities'));
const AsyncInterventionMonitoring = lazy(() => import('../containers/shared/interventions/monitoring'));
const AsyncInterventionComplete = lazy(() => import('../containers/shared/interventions/complete'));
const AsyncInterventionStakeholderCohorts = lazy(() => import('../containers/shared/interventions/stakeholders'));
const AsyncInterventionStakeholders = lazy(() => import('../containers/shared/interventions/stakeholders'));
const AsyncInterventionStakeholderCohortDetails = lazy(() =>
  import('../containers/shared/interventions/stakeholders/CohortDetails')
);
const AsyncInterventionInstitutionCohorts = lazy(() => import('../containers/shared/interventions/institutions'));
const AsyncInterventionInstitutions = lazy(() => import('../containers/shared/interventions/institutions'));
const AsyncInterventionInstitutionCohortDetails = lazy(() =>
  import('../containers/shared/interventions/institutions/CohortDetails')
);

// My Forms
const AsyncMyFormsPage = lazy(() => import('../containers/shared/myForms'));
const AsyncMyFormsSubmissionPage = lazy(() => import('../containers/shared/myForms/submissions/CreateForm'));
const AsyncMyFormsCreateSubmission = lazy(() => import('../containers/shared/myForms/submissions/CreateSubmission'));
const AsyncMyFormsSubmissionCalculate = lazy(() => import('../containers/shared/myForms/submissions/Calculate'));

// My activities
const AsyncActivitiesDetails = lazy(() => import('../containers/shared/activities/ActivitiesDetails'));
const AsyncActivitiesAttendees = lazy(() => import('../containers/shared/activities/forms/ActivityAttendeesForm'));
const AsyncActivitiesSessions = lazy(() => import('../containers/shared/sessions'));
const AsyncActivitiesSessionsCreate = lazy(() => import('../containers/shared/sessions/forms/CreateForm'));
const AsyncManageActivitiesDetails = lazy(() => import('../containers/shared/activities/ManageActivitiesDetails'));
const AsyncManageGroupOptions = lazy(() => import('../containers/shared/activities/groups/options'));
const AsyncActivityForm = lazy(() => import('../containers/shared/activities/forms/ActivityForm'));
const AsyncActivityAssignUsers = lazy(() => import('../containers/shared/activities/forms/ActivityAssignUsers'));

// Indicators
const AsyncIndicators = lazy(() => import('../containers/shared/indicatorFrameworks/pages'));
const AsyncIndicatorPeriods = lazy(() => import('../containers/shared/indicatorFrameworks/pages/IndicatorPeriods'));
const AsyncIndicatorFramework = lazy(() => import('../containers/shared/indicatorFrameworks'));
const AsyncIndicatorFrameworkMonitoring = lazy(() => import('../containers/shared/indicatorFrameworks/monitoring'));
const AsyncIndicatorFrameworkReporters = lazy(() => import('../containers/shared/programmes/reporters'));
const AsyncIndicatorFrameworkReportersAssignees = lazy(() =>
  import('../containers/shared/programmes/reporters/assignees')
);

const AsyncIndicatorFrameworkPeriodGroups = lazy(() => import('../containers/shared/periodGroups'));
const AsyncIndicatorFrameworkPeriodGroupPeriods = lazy(() =>
  import('../containers/shared/periodGroups/IndicatorPeriods')
);
const AsyncIndicatorFrameworkCurrencyGroupPeriods = lazy(() =>
  import('../containers/shared/currencyGroups/IndicatorPeriods')
);
const AsyncIndicatorFrameworkCurrencyGroups = lazy(() => import('../containers/shared/currencyGroups'));

// My Cases
const AsyncMyCases = lazy(() => import('../containers/shared/cases'));
const AsyncClientPage = lazy(() => import('../containers/shared/cases/ClientPage'));
const AsyncConsultationPage = lazy(() => import('../containers/shared/cases/ConsultationPage'));
const AsyncCaseManagement = lazy(() => import('../containers/shared/cases/CaseManagement'));
const AsyncConfigureSession = lazy(() => import('../containers/shared/cases/ConfigureSession'));
const AsyncCaseIdConfiguration = lazy(() => import('../containers/shared/cases/CaseManagement/CaseIdConfiguration'));
const AsyncCaseDetailsConfiguration = lazy(() =>
  import('../containers/shared/cases/CaseManagement/CaseDetailsConfiguration')
);
const AsyncCaseSummaryConfiguration = lazy(() =>
  import('../containers/shared/cases/CaseManagement/CaseSummaryConfiguration')
);

export const institutionRoutes = [
  {
    breadcrumbs: [{ title: 'Home', path: '/institution' }],
    exact: true,
    path: '/institution',
    component: AsyncLanding,
  },
  {
    breadcrumbs: [{ title: 'Home', path: '/institution/insights' }],
    exact: true,
    path: '/institution/insights',
    component: AsyncInsights,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Insights', path: '/institution/insights' },
    ],
    exact: true,
    path: '/institution/insights/:insightType/:insightId',
    component: AsyncInsightsEmbedFrame,
  },
  {
    breadcrumbs: [{ title: 'Home', path: '/institution/my-profile' }],
    exact: true,
    path: '/institution/my-profile',
    component: AsyncProfile,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      { title: 'PeriodGroups', path: '/institution/manage/indicatorFrameworks/period-groups' },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      { title: 'PeriodGroups', path: '/institution/manage/indicatorFrameworks/period-groups' },
      {
        title: 'Periods',
        path: '/institution/manage/indicatorFrameworks/period-groups/:periodGroupId/periods',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'PeriodGroups', path: '/institution/programmes/period-groups' },
    ],
    exact: true,
    path: '/institution/programmes/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'PeriodGroups', path: '/institution/programmes/period-groups' },
      { title: 'Periods', path: '/institution/programmes/period-groups/:periodGroupId/periods' },
    ],
    exact: true,
    path: '/institution/programmes/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Interventions', path: '/institution/interventions' },
      { title: 'PeriodGroups', path: '/institution/programmes/period-groups' },
    ],
    exact: true,
    path: '/institution/interventions/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Interventions', path: '/institution/interventions' },
      { title: 'PeriodGroups', path: '/institution/interventions/period-groups' },
      { title: 'Periods', path: '/institution/interventions/period-groups/:periodGroupId/periods' },
    ],
    exact: true,
    path: '/institution/interventions/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Interventions', path: '/institution/interventions' },
      { title: 'CurrencyGroups', path: '/institution/interventions/currency-groups' },
    ],
    exact: true,
    path: '/institution/interventions/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Interventions', path: '/institution/interventions' },
      { title: 'CurrencyGroups', path: '/institution/interventions/currency-groups' },
      { title: 'Periods', path: '/institution/interventions/currency-groups/:currencyGroupId/periods' },
    ],
    exact: true,
    path: '/institution/interventions/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'CurrencyGroups', path: '/institution/programmes/currency-groups' },
    ],
    exact: true,
    path: '/institution/programmes/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'CurrencyGroups', path: '/institution/programmes/currency-groups' },
      { title: 'Periods', path: '/institution/programmes/currency-groups/:currencyGroupId/periods' },
    ],
    exact: true,
    path: '/institution/programmes/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      { title: 'CurrencyGroups', path: '/institution/manage/indicatorFrameworks/currency-groups' },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      { title: 'CurrencyGroups', path: '/institution/manage/indicatorFrameworks/currency-groups' },
      {
        title: 'Periods',
        path: '/institution/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  // exports
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Data Exports', path: '/institution/exports' },
    ],
    exact: true,
    path: '/institution/exports',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Data Exports', path: '/institution/exports' },
      { title: 'Questions', path: '/institution/exports/:workspaceId/questions' },
    ],
    exact: true,
    path: '/institution/exports/:workspaceId/questions',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Data Exports', path: '/institution/exports' },
      { title: 'Questions', path: '/institution/exports/:workspaceId/questions' },
      { title: 'Question', path: '/institution/exports/:workspaceId/questions/:type/:typeId' },
    ],
    exact: true,
    path: '/institution/exports/:workspaceId/questions/:type/:typeId',
    component: AsyncMetabaseDataExportQuestion,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Profile Data', path: '/institution/exports/profile-data' },
    ],
    exact: true,
    path: '/institution/exports/profile-data',
    component: AsyncExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programme Stats', path: '/institution/exports/programme-stats' },
    ],
    exact: true,
    path: '/institution/exports/programme-stats',
    component: AsyncProgrammeStats,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'School Data Exports', path: '/institution/exports/school-data' },
    ],
    exact: true,
    path: '/institution/exports/school-data',
    component: AsyncMetabaseDataExport,
  },

  // reports
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
    ],
    exact: true,
    path: '/institution/reports',
    component: AsyncReports,
  },
  // IB-1899: periods owed by this organisation (Reports > Requirements)
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Requirements', path: '/institution/reports/requirements' },
    ],
    exact: true,
    path: '/institution/reports/requirements',
    component: AsyncReports,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Create', path: '/institution/reports/create' },
    ],
    exact: true,
    path: '/institution/reports/create',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Create', path: '/institution/reports/create-link' },
    ],
    exact: true,
    path: '/institution/reports/create-link',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Create', path: '/institution/reports/create-report' },
    ],
    exact: true,
    path: '/institution/reports/create-report',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Create', path: '/institution/reports/create-template' },
    ],
    exact: true,
    path: '/institution/reports/create-template',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Templates', path: '/institution/reports/templates' },
    ],
    exact: true,
    path: '/institution/reports/templates',
    component: AsyncReports,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Templates', path: '/institution/reports/templates' },
      { title: 'Create', path: '/institution/reports/templates/:templateId' },
    ],
    exact: true,
    path: '/institution/reports/templates/:templateId',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reports', path: '/institution/reports' },
      { title: 'Edit', path: '/institution/reports/:reportId' },
    ],
    exact: true,
    path: '/institution/reports/:reportId',
    component: AsyncReportDetails,
  },

  // manage institutions
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions',
    component: AsyncInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites',
    component: AsyncInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/institution/manage/institutions/sites/hierarchies' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites/hierarchies',
    component: AsyncProgrammeHierarchies,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/institution/manage/institutions/sites/hierarchies' },
      { title: 'Hierarchy', path: '/institution/manage/institutions/sites/hierarchies/:hierarchyId' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites/hierarchies/:hierarchyId',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/institution/manage/institutions/sites/hierarchies' },
      { title: 'Create', path: '/institution/manage/institutions/sites/hierarchies/create' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites/hierarchies/create',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
      { title: 'Services', path: '/institution/manage/institutions/sites/services' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites/services',
    component: AsyncProgrammeServices,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
      { title: 'Services', path: '/institution/manage/institutions/sites/services' },
      { title: 'Service', path: '/institution/manage/institutions/sites/services/:serviceId' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites/services/:serviceId',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Sites', path: '/institution/manage/institutions/sites' },
      { title: 'Services', path: '/institution/manage/institutions/sites/services' },
      { title: 'Create', path: '/institution/manage/institutions/sites/services/create' },
    ],
    exact: true,
    path: '/institution/manage/institutions/sites/services/create',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/archived',
    component: AsyncArchivedInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      { title: 'Create', path: '/institution/manage/institutions/create' },
    ],
    exact: true,
    path: '/institution/manage/institutions/create',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/people',
    component: AsyncPeople,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/institutions/:institutionId/people' },
      { title: 'Create', path: '/institution/manage/institutions/:institutionId/people/create' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/people/create',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/institutions/:institutionId/people' },
      { title: 'Edit', path: '/institution/manage/institutions/:institutionId/people/:personId' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/people/:personId',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/service-details', // only for ECD Services
    component: AsyncECDServiceDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/service-contacts', // only for ECD Services
    component: AsyncECDServiceContacts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registration-management', // only for ECD Services
    component: AsyncECDServiceRegistrationManagement,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      {
        title: 'ECD Registrations',
        path: '/institution/manage/institutions/:institutionId/registrations',
      },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations',
    component: AsyncECDRegistrations,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      {
        title: 'ECD Registrations',
        path: '/institution/manage/institutions/:institutionId/registrations',
      },
      {
        title: 'New Registration',
        path: '/institution/manage/institutions/:institutionId/registrations/register',
      },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations/register',
    component: AsyncECDApplication,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      {
        title: 'ECD Registrations',
        path: '/institution/manage/institutions/:institutionId/registrations',
      },
      {
        title: 'Application',
        path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/application',
      },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/application',
    component: AsyncECDApplication,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      {
        title: 'ECD Registrations',
        path: '/institution/manage/institutions/:institutionId/registrations',
      },
      {
        title: 'Framework',
        path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/framework',
      },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/framework',
    component: AsyncECDFramework,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      {
        title: 'ECD Registrations',
        path: '/institution/manage/institutions/:institutionId/registrations',
      },
      {
        title: 'Assessment',
        path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/assessment',
      },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/assessment',
    component: AsyncECDAssessment,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
      {
        title: 'ECD Registrations',
        path: '/institution/manage/institutions/:institutionId/registrations',
      },
      {
        title: 'Complete',
        path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/complete',
      },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/complete',
    component: AsyncECDComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Institutions', path: '/institution/manage/institutions' },
    ],
    exact: true,
    path: '/institution/manage/institutions/:institutionId/registrations/:ecdRegistrationId/approve',
    component: AsyncECDApproval,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Templates', path: '/institution/manage/templates' },
    ],
    exact: true,
    path: '/institution/manage/templates',
    component: AsyncInstitutionTemplates,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Templates', path: '/institution/manage/templates' },
      { title: 'Create', path: '/institution/manage/templates/create-new' },
    ],
    exact: true,
    path: '/institution/manage/templates/create-new',
    component: AsyncInstitutionTemplateDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Templates', path: '/institution/manage/templates' },
      { title: 'Edit', path: '/institution/manage/templates/:templateId' },
    ],
    exact: true,
    path: '/institution/manage/templates/:templateId',
    component: AsyncInstitutionTemplateDetails,
  },

  // manage people
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
    ],
    exact: true,
    path: '/institution/manage/people',
    component: AsyncPeople,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
      { title: 'Cohorts', path: '/institution/manage/people/cohorts' },
    ],
    exact: true,
    path: '/institution/manage/people/cohorts',
    component: AsyncPeopleCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
      { title: 'Create', path: '/institution/manage/people/create' },
    ],
    exact: true,
    path: '/institution/manage/people/create',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
      { title: 'Add New', path: '/institution/manage/people/addnew' },
    ],
    exact: true,
    path: '/institution/manage/people/addnew',
    component: AsyncAddPeopleTable,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
      { title: 'Edit', path: '/institution/manage/people/:personId' },
    ],
    exact: true,
    path: '/institution/manage/people/:personId',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
      { title: 'Cohorts', path: '/institution/manage/people/cohorts' },
      { title: 'Create', path: '/institution/manage/people/cohorts/create' },
    ],
    exact: true,
    path: '/institution/manage/people/cohorts/create',
    component: AsyncPeopleCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'People', path: '/institution/manage/people' },
      { title: 'Cohorts', path: '/institution/manage/people/cohorts' },
      { title: 'Edit', path: '/institution/manage/people/cohorts/:cohortId' },
    ],
    exact: true,
    path: '/institution/manage/people/cohorts/:cohortId',
    component: AsyncPeopleCohortDetails,
  },

  // Dashboard
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
    ],
    exact: true,
    path: '/institution/manage/dashboards',
    component: AsyncDashboards,
  },
  // IB-1899 Reporting requirements
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reporting Requirements', path: '/institution/manage/reporting-requirements' },
    ],
    exact: true,
    path: '/institution/manage/reporting-requirements',
    component: AsyncReportingRequirements,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Reporting Requirements', path: '/institution/manage/reporting-requirements' },
      { title: 'Requirement', path: '/institution/manage/reporting-requirements/:requirementId' },
    ],
    exact: true,
    path: '/institution/manage/reporting-requirements/:requirementId',
    component: AsyncReportingRequirementDetail,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Workspace', path: '/institution/manage/dashboards/workspace/:workspaceId' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/workspace/:workspaceId',
    component: AsyncDashboards,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Workspace', path: '/institution/manage/dashboards/workspace/:workspaceId' },
      { title: 'Dashboard', path: '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId',
    component: AsyncDashboardsDashboard,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Workspace', path: '/institution/manage/dashboards/workspace/:workspaceId' },
      { title: 'Users', path: '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/workspace/:workspaceId/:dashboardId/users',
    component: AsyncDashboardsUsers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Metabase', path: '/institution/manage/dashboards/metabase' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/metabase',
    component: AsyncDashboardsMetabase,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Metabase', path: '/institution/manage/dashboards/metabase/:type/:id' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/metabase/:type/:id',
    component: AsyncDashboardsMetabase,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Create', path: '/institution/manage/dashboards/layout/create-new' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/layout/create-new',
    component: AsyncNewDashboardLayout,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Dashboards', path: '/institution/manage/dashboards' },
      { title: 'Edit', path: '/institution/manage/dashboards/layout/:layoutId' },
    ],
    exact: true,
    path: '/institution/manage/dashboards/layout/:layoutId',
    component: AsyncNewDashboardLayout,
  },

  // Team members
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      {
        title: 'Team Members',
        path: '/institution/team-members',
      },
    ],
    exact: true,
    path: '/institution/team-members',
    component: AsyncTeamMembers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Team Members', path: '/institution/team-members/create-new' },
    ],
    exact: true,
    path: '/institution/team-members/create-new',
    component: AsyncTeamMembersCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Team Members', path: '/institution/team-members/:teamMemberId' },
    ],
    exact: true,
    path: '/institution/team-members/:teamMemberId',
    component: AsyncTeamMembersCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Team Members', path: '/institution/team-members' },
      { title: 'Activities', path: '/institution/team-members/:stakeholderId/activities' },
    ],
    exact: true,
    path: '/institution/team-members/:stakeholderId/activities',
    component: AsyncActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      {
        title: 'Sessions',
        path: '/institution/team-members/:stakeholderId/activities/:activityId/sessions',
      },
    ],
    exact: true,
    path: '/institution/team-members/:stakeholderId/activities/:activityId/sessions',
    component: AsyncActivitiesSessions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      {
        title: 'Sessions',
        path: '/institution/team-members/:stakeholderId/activities/:activityId/sessions/create',
      },
    ],
    exact: true,
    path: '/institution/team-members/:stakeholderId/activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Create new session', path: '/institution' },
      { title: 'Activities', path: '/institution/activities' },
      { title: 'Team', path: '/institution/activities/:stakeholderId' },
      { title: 'Sessions', path: '/institution/activities/:activityId/sessions' },
      { title: 'Sessions', path: '/institution/activities/:activityId/sessions/:sessionId' },
    ],
    exact: true,
    path: '/institution/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },

  // notifications
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Notifications', path: '/institution/notifications' },
    ],
    exact: true,
    path: '/institution/notifications',
    component: AsyncNotifications,
  },

  //Admin
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Admin', path: '/institution/admin' },
    ],
    exact: true,
    path: '/institution/admin',
    component: AsyncAdminPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
    ],
    exact: true,
    path: '/institution/admin/workspaces',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      { title: 'Create', path: '/institution/admin/workspaces/create-new' },
    ],
    exact: true,
    path: '/institution/admin/workspaces/create-new',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      { title: 'Edit', path: '/institution/admin/workspaces/:workspaceId' },
    ],
    exact: true,
    path: '/institution/admin/workspaces/:workspaceId',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      { title: 'Overview', path: '/institution/admin/workspaces/:workspaceId/overview' },
    ],
    exact: true,
    path: '/institution/admin/workspaces/:workspaceId/overview',
    component: AsyncAdminWorkspaceOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      {
        title: 'Dataset',
        path: '/institution/admin/workspaces/:workspaceId/overview/datasets/create-new',
      },
    ],
    exact: true,
    path: '/institution/admin/workspaces/:workspaceId/overview/datasets/create-new',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      {
        title: 'Dataset',
        path: '/institution/admin/workspaces/:workspaceId/overview/datasets/:datasetId',
      },
    ],
    exact: true,
    path: '/institution/admin/workspaces/:workspaceId/overview/datasets/:datasetId',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      { title: 'Form', path: '/institution/admin/workspaces/:workspaceId/overview/forms/create-new' },
    ],
    exact: true,
    path: '/institution/admin/workspaces/:workspaceId/overview/forms/create-new',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/admin/workspaces' },
      { title: 'Form', path: '/institution/admin/workspaces/:workspaceId/overview/forms/:formId' },
    ],
    exact: true,
    path: '/institution/admin/workspaces/:workspaceId/overview/forms/:formId',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Templates', path: '/institution/admin/templates' },
    ],
    exact: true,
    path: '/institution/admin/templates',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Modules', path: '/institution/admin/modules' },
    ],
    exact: true,
    path: '/institution/admin/modules',
    component: AsyncAdminModules,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Audit Trail', path: '/institution/admin/audittrail' },
    ],
    exact: true,
    path: '/institution/admin/audittrail',
    component: AsyncAdminAuditTrail,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Organisations', path: '/institution/admin/organisations' },
    ],
    exact: true,
    path: '/institution/admin/organisations',
    component: AsyncAdminOrganisations,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Organisations', path: '/institution/admin/organisations' },
      { title: 'Users', path: '/institution/admin/organisations/:organisationId/users' },
    ],
    exact: true,
    path: '/institution/admin/organisations/:organisationId/users',
    component: AsyncAdminOrganisationsUsers,
  },

  // manage programmes
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
    ],
    exact: true,
    path: '/institution/programmes',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Portfolios', path: '/institution/programmes/portfolios', key: 'Portfolios-tab' },
    ],
    exact: true,
    path: '/institution/programmes/portfolios',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes', key: 'Programmes-tab' },
    ],
    exact: true,
    path: '/institution/programmes',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Create', path: '/institution/programmes/create' },
    ],
    exact: true,
    path: '/institution/programmes/create',
    component: AsyncProgrammeOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Overview', path: '/institution/programmes/:programmeId/overview' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/overview',
    component: AsyncProgrammeOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Indicators', path: '/institution/programmes/:programmeId/indicators' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/indicators',
    component: AsyncProgrammeIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Monitoring', path: '/institution/programmes/:programmeId/monitoring' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/monitoring',
    component: AsyncProgrammeMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Complete', path: '/institution/programmes/:programmeId/complete' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/complete',
    component: AsyncProgrammeComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites',
    component: AsyncProgrammeSites,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/institution/programmes/:programmeId/sites/hierarchies' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites/hierarchies',
    component: AsyncProgrammeHierarchies,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/institution/programmes/:programmeId/sites/hierarchies' },
      { title: 'Hierarchy', path: '/institution/programmes/:programmeId/sites/hierarchies/:hierarchyId' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites/hierarchies/:hierarchyId',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/institution/programmes/:programmeId/sites/hierarchies' },
      { title: 'Create', path: '/institution/programmes/:programmeId/sites/hierarchies/create' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites/hierarchies/create',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
      { title: 'Services', path: '/institution/programmes/:programmeId/sites/services' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites/services',
    component: AsyncProgrammeServices,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
      { title: 'Services', path: '/institution/programmes/:programmeId/sites/services' },
      { title: 'Service', path: '/institution/programmes/:programmeId/sites/services/:serviceId' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites/services/:serviceId',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Sites', path: '/institution/programmes/:programmeId/sites' },
      { title: 'Services', path: '/institution/programmes/:programmeId/sites/services' },
      { title: 'Create', path: '/institution/programmes/:programmeId/sites/services/create' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/sites/services/create',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Reporters', path: '/institution/programmes/:programmeId/reporters' },
      { title: 'Assignees', path: '/institution/programmes/:programmeId/reporters/:reporterId/assignees' },
    ],
    exact: true,
    path: '/institution/programmes/:programmeId/reporters/:reporterId/assignees',
    component: AsyncProgrammeReporterAssignees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions', key: 'Interventions-tab' },
    ],
    exact: true,
    path: '/institution/programmes/interventions',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Create', path: '/institution/programmes/interventions/create' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/create',
    component: AsyncInterventionOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Overview', path: '/institution/programmes/interventions/:interventionId/overview' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/overview',
    component: AsyncInterventionOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Inputs', path: '/institution/programmes/interventions/:interventionId/inputs' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/inputs',
    component: AsyncInterventionInputs,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Indicators', path: '/institution/programmes/interventions/:interventionId/indicators' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/indicators',
    component: AsyncInterventionIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Activities', path: '/institution/programmes/interventions/:interventionId/activities' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/activities',
    component: AsyncInterventionActivities,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Monitoring', path: '/institution/programmes/interventions/:interventionId/monitoring' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/monitoring',
    component: AsyncInterventionMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Complete', path: '/institution/programmes/interventions/:interventionId/complete' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/complete',
    component: AsyncInterventionComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/institution/programmes/interventions/:interventionId/stakeholders',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/stakeholders',
    component: AsyncInterventionStakeholders,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/institution/programmes/interventions/:interventionId/stakeholders',
      },
      {
        title: 'Cohorts',
        path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts',
    component: AsyncInterventionStakeholderCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/institution/programmes/interventions/:interventionId/stakeholders',
      },
      {
        title: 'Cohorts',
        path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts',
      },
      {
        title: 'Create',
        path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/create',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/create',
    component: AsyncInterventionStakeholderCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/institution/programmes/interventions/:interventionId/stakeholders',
      },
      {
        title: 'Cohorts',
        path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts',
      },
      {
        title: 'Create',
        path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId',
    component: AsyncInterventionStakeholderCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/institution/programmes/interventions/:interventionId/institutions',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/institutions',
    component: AsyncInterventionInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/institution/programmes/interventions/:interventionId/institutions',
      },
      {
        title: 'Cohorts',
        path: '/institution/programmes/interventions/:interventionId/institutions/cohorts',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/institutions/cohorts',
    component: AsyncInterventionInstitutionCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/institution/programmes/interventions/:interventionId/institutions',
      },
      {
        title: 'Cohorts',
        path: '/institution/programmes/interventions/:interventionId/institutions/cohorts',
      },
      {
        title: 'Create',
        path: '/institution/programmes/interventions/:interventionId/institutions/cohorts/create',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/institutions/cohorts/create',
    component: AsyncInterventionInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/institution/programmes/interventions/:interventionId/institutions',
      },
      {
        title: 'Cohorts',
        path: '/institution/programmes/interventions/:interventionId/institutions/cohorts',
      },
      {
        title: 'Create',
        path: '/institution/programmes/interventions/:interventionId/institutions/cohorts/:cohortId',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/institutions/cohorts/:cohortId',
    component: AsyncInterventionInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Reporters', path: '/institution/programmes/interventions/:interventionId/reporters' },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/reporters',
    component: AsyncProgrammeReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Programmes', path: '/institution/programmes' },
      { title: 'Interventions', path: '/institution/programmes/interventions' },
      { title: 'Reporters', path: '/institution/programmes/interventions/:interventionId/reporters' },
      {
        title: 'Assignees',
        path: '/institution/programmes/interventions/:interventionId/reporters/:reporterId/assignees',
      },
    ],
    exact: true,
    path: '/institution/programmes/interventions/:interventionId/reporters/:reporterId/assignees',
    component: AsyncProgrammeReporterAssignees,
  },

  // my activities
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Activities', path: '/institution/my-activities' },
    ],
    exact: true,
    path: '/institution/my-activities',
    component: AsyncActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/my-activities' },
      { title: 'Attendees', path: '/institution/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/institution/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/my-activities' },
      { title: 'Attendees', path: '/institution/my-activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/institution/my-activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/my-activities' },
      { title: 'Sessions', path: '/institution/my-activities/:activityId/sessions/' },
    ],
    exact: true,
    path: '/institution/my-activities/:activityId/sessions/',
    component: AsyncActivitiesSessions,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/my-activities' },
      { title: 'Sessions', path: '/institution/my-activities/:activityId/sessions/' },
      { title: 'Create Session', path: '/institution/my-activities/:activityId/sessions/create' },
    ],
    exact: true,
    path: '/institution/my-activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/my-activities' },
      { title: 'Sessions', path: '/institution/my-activities/:activityId/sessions/' },
      { title: 'Update Session', path: '/institution/my-activities/:activityId/sessions/:sessionId' },
    ],
    exact: true,
    path: '/institution/my-activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/activities' },
      { title: 'Activity', path: '/institution/activities/activity/:activityId' },
    ],
    exact: true,
    path: '/institution/activities/activity/:activityId',
    component: AsyncActivitiesAttendees,
  },

  // manage activities
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Activities', path: '/institution/manage/activities' },
    ],
    exact: true,
    path: '/institution/manage/activities',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Groups', path: '/institution/manage/groups' },
    ],
    exact: true,
    path: '/institution/manage/groups',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Groups', path: '/institution/manage/groups' },
      { title: 'Options', path: '/institution/manage/groups/:groupId/options' },
    ],
    exact: true,
    path: '/institution/manage/groups/:groupId/options',
    component: AsyncManageGroupOptions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Services', path: '/institution/manage/services' },
    ],
    exact: true,
    path: '/institution/manage/services',
    component: AsyncManageActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Attendees', path: '/institution/manage/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Attendees', path: '/institution/manage/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Sessions', path: '/institution/manage/activities/:activityId/sessions/' },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId/sessions/',
    component: AsyncManageActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Sessions', path: '/institution/manage/activities/:activityId/sessions/' },
      { title: 'Create Session', path: '/institution/manage/activities/:activityId/sessions/create' },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Sessions', path: '/institution/manage/activities/:activityId/sessions/' },
      {
        title: 'Update Session',
        path: '/institution/manage/activities/:activityId/sessions/:sessionId',
      },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Activity', path: '/institution/manage/activities/activity/:activityId' },
    ],
    exact: true,
    path: '/institution/manage/activities/activity/:activityId',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Create', path: '/institution/manage/activities/create' },
    ],
    exact: true,
    path: '/institution/manage/activities/create',
    component: AsyncActivityForm,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Edit', path: '/institution/manage/activities/:activityId' },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId',
    component: AsyncActivityForm,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Activities', path: '/institution/manage/activities' },
      { title: 'Assign Users', path: '/institution/manage/activities/:activityId/assign-users' },
    ],
    exact: true,
    path: '/institution/manage/activities/:activityId/assign-users',
    component: AsyncActivityAssignUsers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks',
    component: AsyncIndicatorFramework,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
    component: AsyncIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
      {
        title: 'Edit',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId',
    component: AsyncIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      {
        title: 'Monitoring',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring',
    component: AsyncIndicatorFrameworkMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      { title: 'Reporters', path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters' },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters',
    component: AsyncIndicatorFrameworkReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      { title: 'Reporters', path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters' },
      {
        title: 'Assignees',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees',
    component: AsyncIndicatorFrameworkReportersAssignees,
  },
  // My Forms
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/institution/my-forms' },
    ],
    exact: true,
    path: '/institution/my-forms',
    component: AsyncMyFormsPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/institution/my-forms' },
      { title: 'Submissions', path: '/institution/my-forms/:id/submissions' },
    ],
    exact: true,
    path: '/institution/my-forms/:id/submissions',
    component: AsyncMyFormsPage,
  },

  //submission
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions/submit' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions/submit',
    component: AsyncMyFormsCreateSubmission,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/institution/my-forms' },
      { title: 'Submissions', path: '/institution/my-forms/:id/submissions/submit' },
    ],
    exact: true,
    path: '/institution/my-forms/:id/submissions/submit',
    component: AsyncMyFormsCreateSubmission,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/institution/my-forms' },
      { title: 'Submissions', path: '/institution/my-forms/:id/submissions/:submissionId' },
    ],
    exact: true,
    path: '/institution/my-forms/:id/submissions/:submissionId',
    component: AsyncMyFormsSubmissionPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/institution/my-forms' },
      { title: 'Calculate', path: '/institution/my-forms/:id/submissions/:submissionId/calculate' },
    ],
    exact: true,
    path: '/institution/my-forms/:id/submissions/:submissionId/calculate',
    component: AsyncMyFormsSubmissionCalculate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/institution/my-forms' },
      {
        title: 'Calculate',
        path: '/institution/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber',
      },
    ],
    exact: true,
    path: '/institution/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber',
    component: AsyncMyFormsSubmissionCalculate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions/:submissionId' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions/:submissionId',
    component: AsyncMyFormsSubmissionPage,
  },

  // Manage Forms
  // {
  //   breadcrumbs: [{ title: 'Home', path: '/institution' }, { title: 'Forms', path: '/institution/manage/my-forms' }],
  //   exact: true,
  //   path: '/institution/manage/my-forms',
  //   component: AsyncMyFormsPage,
  // },
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/institution' },
  //     { title: 'Forms', path: '/institution/manage/my-forms' },
  //     { title: 'Submissions', path: '/institution/manage/my-forms/:id/submissions' },
  //   ],
  //   exact: true,
  //   path: '/institution/manage/my-forms/:id/submissions',
  //   component: AsyncMyFormsPage,
  // },
  // //submission
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/institution' },
  //     { title: 'Forms', path: '/institution/manage/my-forms' },
  //     { title: 'Submissions', path: '/institution/manage/my-forms/:id/submissions' },
  //   ],
  //   exact: true,
  //   path: '/institution/manage/my-forms/:id/submissions/:submissionId',
  //   component: AsyncMyFormsSubmissionPage,
  // },

  // Manage Insights
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Insights', path: '/institution/manage/insights' },
    ],
    exact: true,
    path: '/institution/manage/insights',
    component: AsyncManageInsights,
  },
  // Create Insight
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Insight', path: '/institution/manage/insights' },
    ],
    exact: true,
    path: '/institution/manage/insights/create-new',
    component: AsyncInsightsDetails,
  },
  // Update Insight
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Insight', path: '/institution/manage/insights' },
    ],
    exact: true,
    path: '/institution/manage/insights/:insightId',
    component: AsyncInsightsDetails,
  },
  // Insight Users
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Insight', path: '/institution/manage/insights' },
      { title: 'Users', path: '/institution/manage/insights/:insightId/users' },
    ],
    exact: true,
    path: '/institution/manage/insights/:insightId/users',
    component: AsyncInsightUsers,
  },

  // Manage Forms

  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
    ],
    exact: true,
    path: '/institution/manage/workspaces',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      { title: 'Create', path: '/institution/manage/workspaces/create-new' },
    ],
    exact: true,
    path: '/institution/manage/workspaces/create-new',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      { title: 'Edit', path: '/institution/manage/workspaces/:workspaceId' },
    ],
    exact: true,
    path: '/institution/manage/workspaces/:workspaceId',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      { title: 'Overview', path: '/institution/manage/workspaces/:workspaceId/overview' },
    ],
    exact: true,
    path: '/institution/manage/workspaces/:workspaceId/overview',
    component: AsyncAdminWorkspaceOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      {
        title: 'Dataset',
        path: '/institution/manage/workspaces/:workspaceId/overview/datasets/create-new',
      },
    ],
    exact: true,
    path: '/institution/manage/workspaces/:workspaceId/overview/datasets/create-new',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      {
        title: 'Dataset',
        path: '/institution/manage/workspaces/:workspaceId/overview/datasets/:datasetId',
      },
    ],
    exact: true,
    path: '/institution/manage/workspaces/:workspaceId/overview/datasets/:datasetId',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      { title: 'Form', path: '/institution/manage/workspaces/:workspaceId/overview/forms/create-new' },
    ],
    exact: true,
    path: '/institution/manage/workspaces/:workspaceId/overview/forms/create-new',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Workspaces', path: '/institution/manage/workspaces' },
      { title: 'Form', path: '/institution/manage/workspaces/:workspaceId/overview/forms/:formId' },
    ],
    exact: true,
    path: '/institution/manage/workspaces/:workspaceId/overview/forms/:formId',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'IndicatorFrameworks', path: '/institution/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
      {
        title: 'Periods',
        path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods',
      },
    ],
    exact: true,
    path: '/institution/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods',
    component: AsyncIndicatorPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Appointments', path: '/institution/manage/cases/appointments' },
    ],
    exact: true,
    path: '/institution/manage/cases/appointments',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
    ],
    exact: true,
    path: '/institution/manage/cases',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Consultations', path: '/institution/manage/cases/consultations' },
    ],
    exact: true,
    path: '/institution/manage/cases/consultations',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Medication Queue', path: '/institution/manage/cases/medication-queue' },
    ],
    exact: true,
    path: '/institution/manage/cases/medication-queue',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Case Management', path: '/institution/manage/cases/case-management' },
    ],
    exact: true,
    path: '/institution/manage/cases/case-management',
    component: AsyncCaseManagement,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Case Management', path: '/institution/manage/cases/case-management' },
      { title: 'Configure', path: '/institution/manage/cases/case-management/activities/:activityId/configure' },
    ],
    exact: true,
    path: '/institution/manage/cases/case-management/activities/:activityId/configure',
    component: AsyncConfigureSession,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Case Management', path: '/institution/manage/cases/case-management' },
      { title: 'Case ID', path: '/institution/manage/cases/case-management/case-id-configuration' },
    ],
    exact: true,
    path: '/institution/manage/cases/case-management/case-id-configuration',
    component: AsyncCaseIdConfiguration,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Case Management', path: '/institution/manage/cases/case-management' },
      { title: 'Case Details', path: '/institution/manage/cases/case-management/case-details-configuration' },
    ],
    exact: true,
    path: '/institution/manage/cases/case-management/case-details-configuration',
    component: AsyncCaseDetailsConfiguration,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Case Management', path: '/institution/manage/cases/case-management' },
      { title: 'Case Summary', path: '/institution/manage/cases/case-management/case-summary-configuration' },
    ],
    exact: true,
    path: '/institution/manage/cases/case-management/case-summary-configuration',
    component: AsyncCaseSummaryConfiguration,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Consultations', path: '/institution/manage/cases/consultations' },
      { title: 'Consultation', path: '/institution/manage/cases/consultations/:consultationId' },
    ],
    exact: true,
    path: '/institution/manage/cases/consultations/:consultationId',
    component: AsyncConsultationPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      { title: 'Cases', path: '/institution/manage/cases' },
      { title: 'Case', path: '/institution/manage/cases/:caseId' },
    ],
    exact: true,
    path: '/institution/manage/cases/:caseId',
    component: AsyncClientPage,
  },
];
